import Select, { components } from "react-select";

import AsyncSelect from "react-select/async";
import React from "react";

/**
 * Dropdown component from an external library
 * for more information review it's documentation:
 * https://react-select.com/props
 */
const Dropdown = ({ async, ...props }) => {
  const IndicatorSeparator = () => <React.Fragment />;

  const DropdownIndicator = (props) =>
    props.isDisabled ? (
      <React.Fragment />
    ) : (
      <i className="bi bi-caret-down-fill"></i>
    );

  const MultiValueRemove = (props) =>
    props?.selectProps?.isDisabled ? (
      <React.Fragment />
    ) : (
      <components.MultiValueRemove {...props} />
    );

  const customComponents = {
    IndicatorSeparator,
    DropdownIndicator,
    MultiValueRemove,
  };

  const isDisabled = props.isDisabled || props.disabled;

  return async ? (
    <AsyncSelect
      styles={selectStyles}
      components={customComponents}
      defaultOptions
      isSearchable
      hideSelectedOptions
      placeholder=""
      isDisabled={isDisabled}
      isClearable={!props.required}
      {...props}
    />
  ) : (
    <Select
      styles={selectStyles}
      components={customComponents}
      isSearchable
      hideSelectedOptions
      placeholder=""
      isDisabled={isDisabled}
      isClearable={!props.required}
      {...props}
    />
  );
};

export default Dropdown;

const selectStyles = {
  control: (styles, props) => {
    let backgroundColor = "";
    let borderColor = "#cdcdcd";
    if (props.selectProps.isValid) borderColor = "#198754";
    if (props.selectProps.isInvalid) borderColor = "#dc3545";
    if (props.selectProps.isDisabled) backgroundColor = "#e9ecef";
    return {
      ...styles,
      overflowY: "auto",
      minHeight: props.selectProps.minHeight || 40,
      padding: "0 8px",
      borderRadius: "0.25rem",
      border: `solid 1px ${borderColor}`,
      backgroundColor: !!backgroundColor
        ? backgroundColor
        : styles.backgroundColor,
      boxShadow: "none",
      "&:hover": {
        border: "solid 1px #3665df",
        boxShadow: "none",
      },
      "&:active": {
        border: "solid 1px #3665df !important",
        boxShadow: "none !important",
      },
    };
  },
  placeholder: (styles) => ({
    ...styles,
    fontSize: 14,
  }),
  menu: (styles) => ({
    ...styles,
    backgroundColor: "#fafafa",
    padding: "0 8px",
    margin: 0,
  }),
  menuList: (styles) => ({
    ...styles,
    padding: 0,
    margin: 0,  
  }),
  option: (styles) => ({
    ...styles,
    height: 'fit-content',
    minHeight: 20,
    margin: "16px 0",
    backgroundColor: "#fafafa",
    fontSize: 14,
    padding: 0,
    "&:hover": {
      backgroundColor: "#fafafa!important",
      boxShadow: "none !important",
    },
  }),
  valueContainer: (styles, props) => ({
    ...styles,
    height: props?.selectProps?.minHeight ? (props.selectProps.minHeight - 2) : styles.height,
  }),
  input: (styles, props) => ({
    ...styles,
    height: props.selectProps.minHeight ? (props.selectProps.minHeight - 8) : styles.height,
  }),
  singleValue: (styles) => ({
    ...styles,
    fontSize: 14,
    color: "#212529",
  }),
  multiValue: (styles, props) => ({
    ...styles,
    padding: props?.selectProps?.isDisabled ? "3px" : "0",
    fontSize: 14,
    height: 25,
    backgroundColor: "#e8e8e8",
    color: "#212529",
  }),
};
